// store/index.ts
const isProd = process.env.NODE_ENV === 'production';
const store = isProd
    ? require('./store.prod').default
    : require('./store.dev').default;
export default store;
